import { Link } from "react-router-dom";
import { Heart, Eye } from "lucide-react";
import { useWishlist } from "@/context/WishlistContext";

export default function ProductCard({ product, onQuickView }) {
  const { has, toggle } = useWishlist();
  const hasIt = has(product.id);
  const img1 = product.images?.[0];
  const img2 = product.images?.[1] || product.images?.[0];

  return (
    <div className="group relative" data-testid={`product-card-${product.id}`}>
      <Link to={`/product/${product.id}`} className="block relative overflow-hidden bg-surface aspect-[3/4]">
        <img
          src={img1}
          alt={product.name}
          className="absolute inset-0 w-full h-full object-cover transition-opacity duration-700 group-hover:opacity-0"
          loading="lazy"
        />
        <img
          src={img2}
          alt={`${product.name} alternate view`}
          className="absolute inset-0 w-full h-full object-cover opacity-0 transition-opacity duration-700 group-hover:opacity-100"
          loading="lazy"
        />
        {/* tags */}
        <div className="absolute top-3 left-3 flex flex-col gap-1">
          {product.is_new && <span className="bg-foreground text-background ie-overline px-2.5 py-1">New</span>}
          {product.compare_at_price && <span className="bg-brand-accent text-background ie-overline px-2.5 py-1">Atelier</span>}
        </div>
      </Link>

      {/* hover utilities */}
      <div className="absolute top-3 right-3 flex flex-col gap-2">
        <button
          onClick={(e) => { e.preventDefault(); toggle(product); }}
          className={`w-9 h-9 flex items-center justify-center bg-background/80 backdrop-blur-sm border border-border hover:bg-background transition-colors ${hasIt ? "text-brand-accent" : ""}`}
          aria-label="Add to wishlist"
          data-testid={`wishlist-toggle-${product.id}`}
        >
          <Heart className={`w-4 h-4 ${hasIt ? "fill-current" : ""}`} />
        </button>
        {onQuickView && (
          <button
            onClick={(e) => { e.preventDefault(); onQuickView(product); }}
            className="w-9 h-9 flex items-center justify-center bg-background/80 backdrop-blur-sm border border-border hover:bg-background transition-colors opacity-0 group-hover:opacity-100"
            aria-label="Quick view"
            data-testid={`quickview-trigger-${product.id}`}
          >
            <Eye className="w-4 h-4" />
          </button>
        )}
      </div>

      {/* details */}
      <div className="pt-4 space-y-1">
        <Link to={`/product/${product.id}`}>
          <h3 className="font-serif text-lg leading-tight group-hover:text-brand-accent transition-colors">{product.name}</h3>
        </Link>
        <div className="ie-overline text-text-secondary">{product.subtitle}</div>
        <div className="flex items-baseline gap-2 pt-1">
          <span className="font-serif text-base">₹{product.price.toLocaleString("en-IN")}</span>
          {product.compare_at_price && (
            <span className="text-xs text-text-secondary line-through">₹{product.compare_at_price.toLocaleString("en-IN")}</span>
          )}
        </div>
      </div>
    </div>
  );
}
